package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Represents a point in the whiteboard canvas.
 * Coordinates are normalized (0.0 to 1.0) relative to canvas dimensions.
 */
@Serializable
data class DrawPoint(
    @SerialName("x")
    val x: Float,

    @SerialName("y")
    val y: Float
)
